export default __webpack_public_path__ + "media/images/logo/media/fujitv-687e42d80f070209a5e3a0f18ceac128.png";